import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import { ProgressStatus } from 'api/project';
import { EmptyCell } from 'components/atoms/empty-cell/index';
import { Progress as OzoneProgress } from 'components/atoms/progress';
import { StatusPopover } from 'components/molecules/status-popover/index';
import { useStatusField } from 'data/fields/hooks';
import { PopoverContent } from './popover';
import { getProgress } from './utils';

export const ProgressStatusBar: FC<{
  progressStatuses: ProgressStatus[];
  showPopover?: boolean;
  strokeWidth?: number;
  subTitle?: string;
  title?: string | any;
  popoverContent?: JSX.Element;
}> = ({
  progressStatuses,
  showPopover = true,
  strokeWidth = 16,
  subTitle,
  title,
  popoverContent,
}) => {
  const statusField = useStatusField();

  if (!isEmpty(progressStatuses)) {
    const progress = getProgress(progressStatuses);
    const { completedPercent, inProgressPercent } = progress;

    return showPopover ? (
      <StatusPopover
        title={title}
        subTitle={subTitle}
        content={popoverContent ?? PopoverContent(progress, statusField)}
      >
        <OzoneProgress
          percent={completedPercent + inProgressPercent}
          success={{ percent: completedPercent }}
          showInfo={false}
          strokeWidth={strokeWidth}
          strokeColor="var(--green-30)"
        />
      </StatusPopover>
    ) : (
      <OzoneProgress
        percent={completedPercent + inProgressPercent}
        success={{ percent: completedPercent }}
        showInfo={false}
        strokeWidth={strokeWidth}
        strokeColor="var(--green-30)"
      />
    );
  }

  return <EmptyCell />;
};
